import type { ResolvedGoOfflineConfig } from "../types";

export const DEFAULT_CONFIG: ResolvedGoOfflineConfig = {
  enabled: true,
  debug: false,
  swPath: "/sw.js",
  scope: "/",
  version: "v1",
  offlinePage: "/offline.html",
  offlineImage: null,
  precache: ["/", "/offline.html"],
  pwa: false,
  runtimeCaching: {
    pages: "network-first",
    images: "cache-first",
    api: "network-first",
    assets: "stale-while-revalidate"
  },
  callbacks: {}
};

export const INSTALL_PROMPT_EVENT = "beforeinstallprompt";
